var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleRightSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3338 3.06267C5.53789 2.96133 5.78176 2.98434 5.96329 3.12207L11.7626 7.52197C11.9122 7.63541 12 7.81228 12 7.99996C12 8.18765 11.9122 8.36452 11.7627 8.47796L5.9633 12.878C5.78177 13.0157 5.53789 13.0388 5.3338 12.9374C5.12971 12.8361 5.00064 12.6279 5.00064 12.4V3.60006C5.00064 3.3722 5.12971 3.16401 5.3338 3.06267ZM6.20064 4.80842V11.1916L10.4073 7.99998L6.20064 4.80842Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleRightSmall);
export default __webpack_public_path__ + "static/media/triangle-right-small.834c878c3b1c01dfdaa16f5c4882128e.svg";
export { ForwardRef as ReactComponent };